import React from 'react';
export const EXTERNAL_PLUGIN_TOOLBAR_ID = 'external-plugin-toolbar';
const RicosPluginToolbarPortal = React.forwardRef(({ toolbarId, className }, ref) => {
    const id = toolbarId
        ? `${EXTERNAL_PLUGIN_TOOLBAR_ID}-${toolbarId}`
        : EXTERNAL_PLUGIN_TOOLBAR_ID;
    return React.createElement("div", { className: className, id: id, ref: ref });
});
export default RicosPluginToolbarPortal;
//# sourceMappingURL=ricos-plugin-toolbar-portal.js.map